var FX = (function(FX, $) {
    $(
        function() {
            FX.HeaderCart.init();
            let $signup_container = $( '.mu_register.wp-signup-container' );
            if ( $signup_container.length > 0 ) {
                let $target = $signup_container.find( 'h2' ).first();
                if ( $target.length > 0 ) {
                    let text = $target.text();
                    if ( text.indexOf( 'is your new username' ) !== -1 ) {
                        let newText = '<span>';
                        newText    += text.substr( 0, text.indexOf( ' ' ) );
                        newText    += '</span>';
                        newText    += text.substr( text.indexOf( ' ' ) );
                        $target.html( newText );
                    }
                }
            }
            if ( FX.username ) {
                $( '#my-account-link' ).append( ' (Hi, ' + FX.username + ')' );
            }
        }
    );
    FX.HeaderCart        = {
        cookieJson: null,
        init: function() {
            if ( document.cookie.indexOf( 'emb_wp_session=' ) !== -1 ) {
                FX.HeaderCart.updateHeaderCart();
            } else {
                FX.HeaderCart.appendValue( 0 );
            }
        },
        checkLocalCartCountCacheLife: function() {
            if ( this.cookieJson !== null && typeof this.cookieJson.lastUpdate !== 'undefined' ) {
                if ( Date.now() - 3600000 > this.cookieJson.lastUpdate ) {
                    // If one hour ago is greater than the cookie's lastUpdate
                    return false;
                }
                return true;
            }
            return false;
        },
        getLocalCartCount: function() {
            // Gets the cart count from the cookie. Returns false if no cookie is present
            if ( this.cookieJson !== null && this.checkLocalCartCountCacheLife() ) {
                return this.cookieJson.cartCount;
            }
            if ( Cookies.get( 'user_cart_count' ) ) {
                this.cookieJson = Cookies.getJSON( 'user_cart_count' );
                if ( this.checkLocalCartCountCacheLife() && typeof this.cookieJson.cartCount === 'number' ) {
                    return this.cookieJson.cartCount;
                }
                return false;
            }
            return false;
        },
        saveLocalCartCount: function( number ) {
            let newCookie = {
                cartCount: parseInt(number),
                lastUpdate: Date.now()
            };
            Cookies.set( 'user_cart_count', newCookie );
            FX.HeaderCart.cookieJson = newCookie;
        },
        updateLocalCartCount: function( difference ) {
            difference = parseInt( difference );
            let localCount = this.getLocalCartCount();
            if ( localCount !== false && typeof parseInt( localCount ) === "number" ) {
                localCount = parseInt( localCount );
                this.saveLocalCartCount( localCount + difference );
            }
        },
        updateHeaderCart: function() {
            let count = this.getLocalCartCount();
            if ( count === false ) {
                var settings = {
                    data: {
                        action: 'get_cart_quantity'
                    },
                    success: function(data) {
                        FX.HeaderCart.appendValue( data.data );
                        FX.HeaderCart.saveLocalCartCount( data.data );
                    }
                };
                $.ajax( FX.ajaxurl, settings );
            } else {
                FX.HeaderCart.appendValue( count );
            }
        },
        appendValue: function( val ) {
            $( '.cart-value' ).remove();
            $( '.cart-option a' ).append( '<span class="cart-value">' + val + '</span>' );
        }
    };
    FX.SelectYourVehicleListenersSetup = false;
    FX.SelectYourVehicleDesktop = {
        make: '',
        model: '',
        year: '',
        cookieJson: null,
        init: function() {
            //console.log( 'initting', this.$el, $(this.$el), $(this.$el).hasClass('js-is-mobile'));
            // Initialize the widget, loading in the values from the cookie if set
            let vehicle = this.getVehicle();
            if ( vehicle.year ) {
                this.year = vehicle.year;
            }
            if ( vehicle.make ) {
                this.make = vehicle.make;
            }
            if ( vehicle.model ) {
                this.model = vehicle.model;
            }
            // Use $nextTick so that it occurs after the DOM has updated
            this.$nextTick($.proxy(this.refineOptions, this));
            if ( false === FX.SelectYourVehicleListenersSetup ) {
                let $body = $('body');
                // Add some listeners for elements outside this component that may need to interact with it
                $body.on('touch click', '#menu-container .choose-vehicle', $.proxy(this.clearAll, this));
                $('.front-product.ymm_reset_vehicle').on('touch click', 'a', $.proxy(this.clearAll, this));
                $('.front-product.ymm_respect_vehicle').on('touch click', 'a', $.proxy(this.injectVehicle, this));
                $body.on('touch click', 'a.js-menu-respect-vehicle', $.proxy(this.injectVehicle, this));
                // Since the desktop and mobile widgets exist separately in the DOM, we need to use a flag to prevent duplicate event listeners
                FX.SelectYourVehicleListenersSetup = true;
            }
        },
        injectVehicle: function( e ) {
            let $a = $( e.currentTarget ),
                href = $a.attr( 'href' ),
                regex = /\/products\//;
            console.log( 'original', href );
            if ( false === regex.test( href ) ) {
                console.log( 'regex failed, ignoring Y/M/M widget' );
                return true;
            }
            let parts = href.split( '/' ),
                productsIdx = parts.indexOf( 'products' );
            console.log( 'original parts', parts );
            if ( this.getVehicle() && this.getVehicle().make ) {
                console.log(parts[productsIdx+1], this.getVehicle().make, FXSelectYourVehicleData.raw.makes.indexOf(parts[productsIdx+1]));
                if ( parts[++productsIdx] !== this.getVehicle().make ) {
                    if ( -1 === FXSelectYourVehicleData.raw.makes.indexOf( parts[productsIdx] ) ) {
                        parts.splice( productsIdx, 0, this.getVehicle().make );
                    } else {
                        parts.splice( productsIdx, 1, this.getVehicle().make );
                    }
                }
                console.log( 'make complete', parts );
                if ( this.getVehicle() && this.getVehicle().model ) {
                    if ( parts[++productsIdx] !== this.getVehicle().model ) {
                        if ( -1 === FXSelectYourVehicleData.raw.models.indexOf( parts[productsIdx] ) ) {
                            parts.splice( productsIdx, 0, this.getVehicle().model );
                        } else {
                            parts.splice( productsIdx, 1, this.getVehicle().model );
                        }
                    }
                }
                console.log( 'model complete', parts );
                if ( this.getVehicle() && this.getVehicle().year && parts[++productsIdx] !== this.getVehicle().year ) {
                    if ( ! /\d{4}/.test( parts[productsIdx] ) ) {
                        parts.splice( productsIdx, 0, this.getVehicle().year );
                    } else {
                        parts.splice( productsIdx, 1, this.getVehicle().year );
                    }
                }
                console.log( 'year complete', parts );
            }
            $a.attr( 'href', parts.join( '/' ) );
            console.log( 'new', $a.attr( 'href' ) );
        },
        refreshDropdowns: function() {
            // Refreshes the dropdowns based off the existing items
            this.initSelect2(this.$refs.yearSelect);
            this.initSelect2(this.$refs.makeSelect);
            this.initSelect2(this.$refs.modelSelect);
            //console.log('@FX refreshDropdowns', this.year, this.make, this.model);
        },
        refineOptions: function() {
            this.regenYearOptions();
            this.regenMakeOptions();
            this.regenModelOptions();
            //console.log('@FX refineOptions', this.year, this.make, this.model);
            // Based off the current values, refine the options available
            this.$nextTick($.proxy(this.refreshDropdowns, this));
        },
        getVehicle: function() {
            // Gets the vehicle from the cookie. Returns false if no cookie is present
            if ( this.cookieJson !== null ) {
                return this.cookieJson;
            }
            if ( Cookies.get( 'user_vehicle' ) ) {
                this.cookieJson = Cookies.getJSON( 'user_vehicle' );
                return this.cookieJson;
            }
            return false;
        },
        clearAll: function() {
            // Unsets the year/make/model
            this.year = '';
            this.make = '';
            this.model = '';
            this.setCookie();
            this.$nextTick($.proxy(this.refineOptions, this));
        },
        setCookie: function() {
            this.cookieJson = null;
            if ( ! this.year && ! this.make ) {
                Cookies.remove( 'user_vehicle' );
            } else {
                Cookies.set( 'user_vehicle', { year: this.year, make: this.make, model: this.model } );
            }
        },
        // Dropdown option swaps
        regenYearOptions: function() {
            //console.log('refreshing years');
            let years = '';
            if ( this.model ) {
                // Years for the selected model
                //console.log( 'this.model set', this.model, FXModelYears[ this.model ] );
                years = FXSelectYourVehicleData.ModelYears[ this.model ];
            } else if ( this.make ) {
                //console.log( 'this.make set', this.make, FXMakeYears[ this.make ] );
                // Years for the selected make
                years = FXSelectYourVehicleData.MakeYears[ this.make ];
            } else {
                //console.log( 'no make/model set', FXYears );
                // All years
                years = FXSelectYourVehicleData.Years;
            }
            this.replaceOptions( 'yearSelect', years, this.year );
        },
        regenMakeOptions: function() {
            //console.log('refreshing makes');
            let makes = '';
            if ( this.year ) {
                // Makes for the selected year
                makes = FXSelectYourVehicleData.YearMakes[ this.year ];
            } else {
                // All makes
                makes = FXSelectYourVehicleData.Makes;
            }
            this.replaceOptions( 'makeSelect', makes, this.make );
        },
        regenModelOptions: function() {
            //console.log('refreshing models', this.make);
            let models = '';
            if ( this.make ) {
                if ( this.year ) {
                    //console.log('calling intersect', this.make, this.year, FXMakeModels[this.make], FXYearModels[this.year]);
                    models = this.intersect( FXSelectYourVehicleData.MakeModels[ this.make ], FXSelectYourVehicleData.YearModels[ this.year ]);
                } else {
                    models = FXSelectYourVehicleData.MakeModels[ this.make ];
                }
            } else {
                // All models, but does it really matter since it'll be disabled? Maybe just the empty option to speed things up
                models = [];
            }
            //console.log('models', models);
            this.replaceOptions( 'modelSelect', models, this.model );
        },
        // Helper functions
        replaceOptions: function(refName, options, currentValue) {
            //console.log('replaceOptions: options', refName, options, currentValue, this.$refs);
            options.forEach($.proxy(function(ele, ind) {
                if ( currentValue == ele.id ) {
                    //console.log('currentValue matched');
                    this.$refs[refName][ind+1] = new Option(ele.text, ele.id, false, true);
                } else {
                    //console.log('currentValue didn\'t match');
                    this.$refs[refName][ind+1] = new Option(ele.text, ele.id);
                }
            }, this));
            //console.log('ref debug', this.$refs[refName].options.length, this.$refs[refName].options, this.$refs[refName]);
            if ((options.length + 1) < this.$refs[refName].options.length) {
                //console.log('purging extra options', options.length, this.$refs[refName].options.length, this.$refs[refName].options);
                for ( let i = options.length + 1; i < this.$refs[refName].options.length; i++ ) {
                    //console.log('deleting', this.$refs[refName][i]);
                    this.$refs[refName][i] = null;
                    --i; // Since we just unset one, reset to catch the one that replaced it
                }
                //console.log('done purging extra options', options.length, this.$refs[refName].options.length, this.$refs[refName].options);
            }
        },
        intersect: function(a, b) {
            let intersection = [];
            a.forEach(
                function(aEle, aInd) {
                    b.some(
                        function(bEle, bInd) {
                            if ( aEle.id === bEle.id && aEle.text === bEle.text ) {
                                intersection.push(aEle);
                                return true;
                            }
                            return false;
                        }
                    )
                }
            );
            return intersection;
        },
        initSelect2: function (el, args) {
            let $el = $(el);
            const settings = $.extend({
                dropdownCssClass: 'select-your-vehicle__open',
                dropdownParent: $el.parents('.selected-main-area'),
                minimumResultsForSearch: 7,
                allowClear: true
            }, args);
            $el.select2(settings).on('select2:select select2:unselect', this.setupSelectEvent);
        },
        setupSelectEvent: function (e) {
            var that = this;
            if ( !!window.MSInputMethodContext && !!document.documentMode ) {
                setTimeout(function () {
                    // Make sure native "change" event gets sent on select2:select
                    let event = document.createEvent('Event');
                    event.initEvent('change', false, true);
                    $(that).get(0).dispatchEvent(event);
                }, 500);
            } else {
                // Make sure native "change" event gets sent on select2:select
                let event = document.createEvent('Event');
                event.initEvent('change', false, true);
                $(that).get(0).dispatchEvent(event);
            }
        }
    };
    FX.SelectYourVehicleMobile = jQuery.extend(true, {}, FX.SelectYourVehicleDesktop);
    return FX;
}( FX || {}, jQuery ) );
